
// src/app/transactions-table/transactions-table.component.ts
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { DfsService } from '../../services/dfs.service';
import { Transaction } from '../../models/dfs-events.models';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { WithdrawalComponent } from "./withdrawal/withdrawal.component";
import { MatCardModule } from '@angular/material/card';
import { WalletSummaryComponent } from '../dashboard/wallet-summary/wallet-summary.component';

@Component({
  selector: 'app-wallet',
  imports: [
    MatPaginatorModule,
    MatTableModule,
    CommonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatButtonToggleModule,
    WithdrawalComponent,
    WalletSummaryComponent
],
  templateUrl: './wallet.component.html',
  styleUrl: './wallet.component.scss'
})
export class WalletComponent {

  displayedColumns: string[] = [
    'date',
    'category',
    'amount',
    'type',
    'status',
    'transactionId',
    'paymentType'
  ];

  dataSource: MatTableDataSource<Transaction> = new MatTableDataSource<Transaction>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  // Toggle filter options
  filterOptions: string[] = ['Both', 'Credit', 'Debit'];
  selectedFilter: string = 'Both';

  isLoading: boolean = true;
  errorMessage: string = '';

  constructor(private dfsService: DfsService) { }

  ngOnInit(): void {
    this.fetchTransactions();
  }

  ngAfterViewChecked(): void {
    if (!this.dataSource.paginator && this.paginator) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.filterPredicate = (data: Transaction, filter: string) => {
        if (filter === '') {
          return true;
        }
        return data.type.toLowerCase() === filter;
      };
    }
  }

  fetchTransactions(): void {
    this.dfsService.getTransactions().subscribe({
      next: (response) => {
        this.dataSource.data = response.data;
        this.isLoading = false;
        this.applyTypeFilter(); // Apply initial filter
      },
      error: (error) => {
        console.error('Error fetching transactions:', error);
        this.errorMessage = 'Failed to load transactions. Please try again later.';
        this.dataSource.data = [];
        this.isLoading = false;
      }
    });
  }

  applyTypeFilter(): void {
    if (this.selectedFilter === 'Both') {
      this.dataSource.filter = ''; // No filter
    } else {
      this.dataSource.filter = this.selectedFilter.trim().toLowerCase();
    }

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  // Handle toggle button change
  onFilterChange(filter: string): void {
    this.selectedFilter = filter;
    this.applyTypeFilter();
  }

}
